import { Pipe, PipeTransform } from '@angular/core';
import memoize from '@github/memoize/decorator';
import { Currency } from '..';
import { FinancialUtils } from '../utils/financial';

@Pipe({ name: 'fromCents' })
export class FromCentsPipe implements PipeTransform {
  @memoize()
  public transform(
    value?: number | null,
    ...args: (string | number | boolean | Currency)[]
  ): number {
    return FinancialUtils.fromCents(value || 0);
  }
}
